import React from 'react';
import { TemplateType } from '../TemplateType';
import usePdfContent, { PdfContentParams } from '../usePdfContent';
import { useTranslation } from 'react-i18next';

import Grid from '@material-ui/core/Grid';

import { formatAmountValue } from 'helpers/helpers';
import PdfContent from 'apps/Pdf/components/common/PdfContent';
import Title from 'apps/Pdf/components/common/Title';
import H1 from 'apps/Pdf/components/common/H1';
import H2 from 'apps/Pdf/components/common/H2';
import P from 'apps/Pdf/components/common/P';
import BasicData from 'apps/Pdf/components/BasicData/BasicData';
import Loading from 'apps/Pdf/components/common/Loading';
import Signature from 'apps/Pdf/components/Signature/Signature';

import useGeneralStyles from 'apps/Pdf/styles/general';
import useColorStyles from 'apps/Pdf/styles/colors';
import { MoneyTransferContent } from './MoneyTransferInterface';
import { PdfCategory } from '../Interfaces';

const MoneyTransfer = (params: PdfContentParams) => {
  const styles = useGeneralStyles();

  const pdfContent = usePdfContent<MoneyTransferContent>({
    category: PdfCategory.SIGNATURE,
    templateType: TPL_MONEY_TRANSFER,
    ...params,
  });

  const data = pdfContent?.data ? pdfContent.data : ({} as MoneyTransferContent);
  const colors = useColorStyles({ code: pdfContent?.data?.header.signedVia || '' });
  const { t } = useTranslation();

  return pdfContent ? (
    <PdfContent errors={pdfContent?.errors} className={colors.root} onload afterLoad={params.afterLoad}>
      <Title>Žádost o převod aktiv</Title>
      <BasicData data={pdfContent.data!.header} />
      <P>Žádám o níže uvedený převod z účtu {data.overview.accountTitle}</P>
      <H1>Převod aktiv</H1>

      <div className={`${styles.twoColumns}`}>
        <Grid container className={styles.lines}>
          <H2>Částka pro převod</H2>
          <Grid item xs={12} className={styles.regularText}>
            {data.overview.transferAll ? (
              'vybrat vše'
            ) : (
              <>{formatAmountValue(data.overview.amount!.value, data.overview.amount!.currency)} (částečný převod z účtu)</>
            )}
          </Grid>
        </Grid>
        <Grid container className={styles.lines}>
          <H2>Na účet klienta</H2>
          <Grid item xs={12} className={styles.regularText}>
            {data.overview.targetAccountTitle}
          </Grid>
        </Grid>
      </div>

      <H2>Plánované převody portfolií</H2>

      <div className={`${styles.twoColumns}`}>
        <Grid container className={styles.lines}>
          <H2>
            <div style={{ width: '50%' }}>Odkud</div>
            <div style={{ width: '50%' }}>Částka</div>
          </H2>
          {data.overview.items.map((item) => (
            <Grid container item xs={12} className={styles.regularText}>
              <Grid item xs={6}>
                {t(`accountDetail_transfer_${item.from}`)}
              </Grid>
              <Grid item xs={6}>
                {item.value ? formatAmountValue(item.value.value, item.value!.currency) : 'vše'}
              </Grid>
            </Grid>
          ))}
        </Grid>
        <Grid container className={styles.lines}>
          <H2>Kam</H2>
          {data.overview.items.map((item) => (
            <Grid container item xs={12} className={styles.regularText}>
              <Grid item xs={12}>
              {t(`accountDetail_transfer_${item.to}`)}
              </Grid>
            </Grid>
          ))}
        </Grid>
      </div>

      <P>
        Po potvrzení může trvat 7—15 dní, než se provedou všechny transakce a cenné papíry se převedou na vybrané
        portfolio zákazníka.
      </P>

      <Signature protocol={data.signedInfo} />
    </PdfContent>
  ) : params.preview ? (
    <Loading />
  ) : null;
};

const TPL_MONEY_TRANSFER: TemplateType = 'moneyTransfer';
export { TPL_MONEY_TRANSFER, MoneyTransfer };
